<template>
  <div id="logged-in-layout">
    <div class="page">
      <transition name="slide-fade">
        <vertical-navbar v-if="!isSmallWindow && isShown" />
      </transition>

      <div class="content-section" ref="content-section">
        <transition name="fade">
          <horizontal-navbar @toggleSidebar="toggleSidebar" />
        </transition>
        <!-- <perfect-scrollbar ref="scroll"> -->
        <div id="router-view" class="router-view">
          <transition name="fade" mode="out-in">
            <div class="page-title" ref="page-title">
              {{ $t(pageTitle) }}
            </div>
          </transition>
          <div id="router" ref="router">
            <transition name="fade" mode="out-in">
              <router-view />
            </transition>
          </div>
          <up-button />
        </div>
        <!-- </perfect-scrollbar> -->
      </div>
    </div>
  </div>
</template>
<script>
import HorizontalNavbar from "@/views/Layout/LayoutComponents/HorizontalNavbar";
import VerticalNavbar from "@/views/Layout/LayoutComponents/VerticalNavbar";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "LoggedInLayout",
  components: {
    HorizontalNavbar,
    VerticalNavbar
  },
  data() {
    return {
      isSmallWindow: false,
      isShown: true,
      pageTitle: undefined
    };
  },
  created() {
    this.readCurrentUser().catch(() => {
      this.removeUserInfo();
      this.$router.push("/login");
    });
    this.setIsSmallWindowProp();
    this.pageTitle = this.$route.meta.pageTitle;
  },
  mounted() {
    this.setSidebarWidth();
    this.setPageTitleHeight();
  },
  methods: {
    ...mapActions({
      setSidebarStatus: "layout/setSidebarStatus",
      readCurrentUser: "user/readCurrentUser",
      removeUserInfo: "user/removeUserInfo"
    }),
    setPageTitleHeight() {
      setTimeout(() => {
        const pageTitleHeight = this.$refs["page-title"].clientHeight;
        document.getElementById(
          "router"
        ).style.height = `calc(100% - ${pageTitleHeight}px)`;
      }, 250);
    },
    setSidebarWidth() {
      this.$refs["content-section"].style.width = this.getSidebarStatus
        ? `calc(100vw - ${this.$variables.layout.sidebarWidth}px)`
        : "100vw";
    },
    toggleSidebar() {
      this.isShown = !this.isShown;
      const payload = !this.isSmallWindow && this.isShown;
      this.setSidebarStatus(payload);
    },
    setIsSmallWindowProp() {
      if (this.getWindowWidth < this.$variables.layout.navbarBreakpoint) {
        this.isSmallWindow = true;
      } else {
        this.isSmallWindow = false;
      }
      const payload = !this.isSmallWindow && this.isShown;
      this.setSidebarStatus(payload);
    }
  },
  computed: {
    ...mapGetters({
      getWindowWidth: "layout/getWindowWidth",
      getSidebarStatus: "layout/getSidebarStatus",
      getActiveUser: "user/getActiveUser"
    })
  },
  watch: {
    $route() {
      this.pageTitle = this.$route.meta.pageTitle;
      this.$eventBus.closeSidebar();
      this.setPageTitleHeight();
    },
    getWindowWidth() {
      this.setIsSmallWindowProp();
    },
    getSidebarStatus() {
      this.setSidebarWidth();
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@/styles/variables.scss";
#logged-in-layout {
  .page {
    min-width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: row;
    .content-section {
      position: relative;
      transition: all 0.5s ease-in;
      .router-view {
        width: 100%;
        height: calc(100vh - 90px);
        padding: 20px;
        overflow: hidden;
        overflow-y: scroll;
        scroll-behavior: smooth;
        .page-title {
          margin-left: 5px;
          margin-right: 15px;
          font-size: 20px;
          font-weight: bold;
          // margin-bottom: 20px;
        }
        #router {
          // height: calc(100% - 24px);
          position: relative;
          width: 100%;
        }
        /* Hide scrollbar for IE, Edge and Firefox */
        -ms-overflow-style: none; /* IE and Edge */
        scrollbar-width: none; /* Firefox */
      }
      /* Hide scrollbar for Chrome, Safari and Opera */
      .router-view::-webkit-scrollbar {
        display: none;
      }
    }
  }
}
@media (max-width: 500px) {
  .router-view {
    padding-right: 10px !important;
    padding-left: 10px !important;
  }
}
</style>
